import techPhoto from '../media/images/companies/technology.jpg';
import electricPhoto from '../media/images/companies/electric.jpg';
import constructionPhoto from '../media/images/companies/construction.jpg';

import techLogo from '../media/images/smart-technology-solutions-white-logo.png';
import electricLogo from '../media/images/smart-electric-solutions-white-logo.png';
import constructionLogo from '../media/images/smart-construction-solutions-white-logo.png';

export const contact = {
    phone: '+1 (305) 205-6409',
    phoneHref: 'tel:+13052056409',
    address: '3040 N 29th Ave #1, Hollywood, FL 33020',
    addressHref: 'https://maps.google.com/?q=3040+N+29th+Ave+%231+Hollywood+FL+33020'
};

export const companies = [
    {
        id: 'technology',
        name: 'Smart Technology Solutions',
        short: 'Technology',
        discipline: 'Low voltage & automation',
        accent: '#A3E7FC',
        url: 'https://smart-tech.solutions/',
        instagram: 'https://www.instagram.com/sts_smart_tech_solutions/',
        logo: techLogo,
        photo: techPhoto,
        focus: '30% 52%',   // the keypad sits left of centre
        body: 'We design and integrate residential and commercial smart systems that are secure, reliable, and easy to use. Our team delivers thoughtful engineering, clean implementation, and seamless control so homes and businesses run better.',
        services: [
            'Consultation',
            'Project Specification',
            'System Design & Engineering',
            'Lighting Design',
            'System Documentation',
            'As-Built Documentation',
            'Wiring & Installation',
            'Low Voltage Electrical',
            'Access Control',
            'Wi-Fi & Networks',
            'BDA & DAS Systems',
            'Programming',
            'System Monitoring',
            'Maintenance & Support',
            'Custom Software'
        ]
    },
    {
        id: 'electric',
        name: 'Smart Electric Solutions',
        short: 'Electric',
        discipline: 'High voltage electrical',
        accent: '#FDE382',
        url: 'https://smartelectric.solutions/',
        instagram: 'https://www.instagram.com/ses_smart_electric_solutions/',
        logo: electricLogo,
        photo: electricPhoto,
        focus: '62% 42%',   // hold the lit ceiling run and the wall panel
        body: 'We are a full-service residential and commercial electrical contractor specializing in modern electrical systems, centralized and distributed, bringing a century-old profession into the 21st century. We can handle any type of electrical work.',
        services: [
            'Consultation',
            'Project Specification',
            'System Design & Engineering',
            'Lighting Design',
            'System Documentation',
            'As-Built Documentation',
            'Wiring & Installation',
            'High Voltage Electrical',
            'Fire Alarm Systems',
            'Generator Installations',
            'PV / Solar Wiring',
            'Switchgear Rooms',
            'Mid & High Rise Buildings',
            'Service & Maintenance',
            'New Construction'
        ]
    },
    {
        id: 'construction',
        name: 'Smart Construction Solutions',
        short: 'Construction',
        discipline: 'Framing, drywall & finishes',
        accent: '#FDB863',
        url: 'https://smartconstruction.solutions/',
        instagram: 'https://www.instagram.com/scs_smart_constr_solutions/',
        logo: constructionLogo,
        photo: constructionPhoto,
        focus: '46% 38%',   // the plaster wall, not the floor
        body: 'We are a full-service residential and commercial drywall, framing, and finish company staffed by people with decades of experience. Our attention to detail and knowledge of multiple trades lets us foresee conflicts and solve them systematically, so projects flow with efficiency.',
        services: [
            'Framing',
            'Drywall',
            'Plaster',
            'Painting',
            'Trims',
            'Doors',
            'Wallpaper',
            'Demolition'
        ]
    }
];

export const manifesto =
    'Three companies. One team. Electrical, low voltage, and interior construction: ' +
    'engineered together, coordinated under one roof, and delivered by people who have ' +
    'already solved the conflict before it reaches your site.';

export const trades = [
    'Low Voltage', 'High Voltage', 'Automation', 'Framing', 'Lighting Design',
    'Drywall', 'Access Control', 'Switchgear', 'Plaster', 'Networks',
    'Fire Alarm', 'Painting', 'Solar & PV', 'Programming', 'Trims & Doors'
];

export const process = [
    {
        step: '01',
        title: 'One call',
        body: 'A single point of contact scopes the whole project (power, low voltage, and interior build) instead of three separate conversations that have to be reconciled later.'
    },
    {
        step: '02',
        title: 'One coordinated plan',
        body: 'Our teams design against each other’s drawings from day one. Conflicts get resolved on paper, where they cost nothing, rather than in the field.'
    },
    {
        step: '03',
        title: 'One team on site',
        body: 'Schedules are synchronized across trades, so rough-in, wiring, and finish work hand off cleanly. Fewer trips, less downtime, one company accountable for the result.'
    }
];

export const advantages = [
    {
        title: 'Integrated solutions',
        body: 'By managing every aspect of electrical, low voltage, and interior construction, we ensure seamless coordination and streamlined processes, saving time and removing the room for miscommunication.'
    },
    {
        title: 'Cost efficiency',
        body: 'Our comprehensive service offering allows for bundled pricing that reduces overall project cost. You get the economies of scale that come from one provider covering multiple needs.'
    },
    {
        title: 'Expertise and experience',
        body: 'With specialized teams across technology, electric, and construction, you get top-tier expertise in every area. Our professionals collaborate to deliver innovative, efficient, high-quality outcomes.'
    },
    {
        title: 'Simplified project management',
        body: 'A single point of contact means easier communication and simpler management. We handle the complexity so you can stay focused on your core business.'
    },
    {
        title: 'Quality assurance',
        body: 'Our integrated approach holds every component of your project to the same standard, from electrical wiring to advanced technology systems to construction finishes.'
    },
    {
        title: 'Faster completion',
        body: 'Coordination between in-house teams shortens timelines. We synchronize schedules and workflows to minimize downtime and accelerate delivery.'
    },
    {
        title: 'Innovative solutions',
        body: 'Leveraging our combined expertise, we offer cutting-edge solutions tailored to your needs. A holistic approach ensures every element of the project works together.'
    },
    {
        title: 'Reliability and trust',
        body: 'With The Smart Solutions Group you gain a partner committed to exceptional service and support. Our reputation for reliability is built on a foundation of satisfied clients.'
    }
];
